export default __webpack_public_path__ + "static/media/tokenB2EMb2.12373473.png";